/** @format */

// 规则
export interface DenoiseRuleProps {
  Label: string
  Operator: string
  Type: 'severity' | 'tag'
  Values: string[]
}
export const initDenoiseRule: DenoiseRuleProps = {
  Type: 'severity',
  Label: 'severity',
  Operator: '=',
  Values: []
}

// 告警抑制数据
export interface DenoiseInhibitionEditProps {
  ID?: number
  Name: string
  Description: string
  InstanceIDs: string[]
  SourceParallelMatchers: DenoiseRuleProps[][]
  TargetParallelMatchers: DenoiseRuleProps[][]
  Equals: string[]
}
export const initInhibitionFormValues: DenoiseInhibitionEditProps = {
  Name: '',
  Description: '',
  InstanceIDs: [],
  SourceParallelMatchers: [[initDenoiseRule]],
  TargetParallelMatchers: [[initDenoiseRule]],
  Equals: ['']
}

// 告警静默数据
export interface DenoiseSilenceEditProps {
  ID?: number
  Name: string
  Description: string
  InstanceIDs: string[]
  ParallelMatchers: DenoiseRuleProps[][]
  Time: [number, number]
  Duration: string
}
export const initSilenceFormValues: DenoiseSilenceEditProps = {
  Name: '',
  Description: '',
  InstanceIDs: [],
  ParallelMatchers: [[initDenoiseRule]],
  Time: undefined,
  Duration: ''
}

// 静默状态
export const SilenceStatusEnum = {
  0: '全部',
  1: '生效中',
  2: '待生效',
  3: '已过期'
}
